window.updatePaidHours = function (e) {
  const row = $(e.target).closest('tr.availability-row');
  const fromTimeParts = $('.from-time').val().split(':');
  const fromTime = parseInt(fromTimeParts[0]) + parseInt(fromTimeParts[0]);
  let paidMinutes =
    window.stringToMinutes(row.find('.to-time').val()) -
    window.stringToMinutes(row.find('.from-time').val()) -
    parseInt(`0${row.find('.js-break-time').val()}`);
  paidMinutes = (paidMinutes + 24 * 60) % (24 * 60);

  row.find('.paid-hours').val((paidMinutes / 60.0).toFixed(2));
  window.updateTotal();
};

window.updateTotal = function () {
  const rows = $('tr.availability-row');
  let totalShifts = 0;
  let totalHours = 0;

  $.each(rows, (index, row) => {
    const hours = parseFloat($(row).find('.paid-hours').val());
    totalHours += hours;
    totalShifts += hours == 0 ? 0 : 1;
  });

  $('.total-shifts').text(totalShifts);
  $('.total-paid-hours').text(totalHours.toFixed(2));
};

window.stringToMinutes = function (str) {
  const parts = str.split(':');
  return parseInt(`0${parts[0]}`) * 60 + parseInt(`0${parts[1]}`);
};

$(() => {
  $('.timeentry').timeEntry({ show24Hours: true, spinnerImage: '' });
  $('.availability-field .timeentry, .js-break-time').on('change', updatePaidHours);
  $('.availability-field .from-time').change();
});
